import _app from '../../../server';

import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table } from 'reactstrap';

const tdStyle = {
    width: '1px',
    whiteSpace: 'nowrap'
};

function UserInfo(props) {
    let img_link = props.link;
    if (props.container !== null && props.filename !== null) {
        let storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
        img_link = `${_app.api}Storages/${props.container}/download/${props.filename}?access_token=${storage.info.id}`;
    }

    return (
        <Row>
            <Col sm='4' className='text-center mt-0 mt-sm-2 mb-3 mb-sm-0 mb-xl-3'>
                <img
                    src={img_link}
                    className='img-thumbnail text-center'
                    alt='Marshal'
                    style={{ height: '100px', width: 'auto' }}
                />
            </Col>
            <Col sm='8'>
                <Table size='sm'>
                    <tbody>
                        <tr>
                            <td className='border-0' style={tdStyle}>
                                {' '}
                                <small>
                                    <strong>Name</strong>
                                </small>{' '}
                            </td>
                            <td className='border-0'>
                                : <small>{props.name}</small>
                            </td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>
                                {' '}
                                <small>
                                    <strong>Staff No.</strong>
                                </small>{' '}
                            </td>
                            <td>
                                : <small>{props.staffId}</small>
                            </td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>
                                {' '}
                                <small>
                                    <strong>Email</strong>
                                </small>{' '}
                            </td>
                            <td>
                                : <small>{props.email}</small>
                            </td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>
                                {' '}
                                <small>
                                    <strong>Phone</strong>
                                </small>{' '}
                            </td>
                            <td>
                                : <small>{props.phoneNumber}</small>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>
    );
}

UserInfo.propTypes = {
    link: PropTypes.string,
    container: PropTypes.string,
    filename: PropTypes.string,
    name: PropTypes.string,
    staffId: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string
};

export default UserInfo;




// WEBPACK FOOTER //
// ./src/components/blocks/UserInfo/UserInfo.js